// src/index.tsx
import React      from 'react'
import ReactDOM   from 'react-dom/client'
import './index.css'
import App        from './app/App'
import reportWebVitals from './reportWebVitals'

import { AdapterDateFns }      from '@mui/x-date-pickers/AdapterDateFns'
import { LocalizationProvider } from '@mui/x-date-pickers'


const root = ReactDOM.createRoot(document.getElementById('root')!)
root.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <App />
    </LocalizationProvider>
  </React.StrictMode>
)

// performance (optional)
reportWebVitals()
